import { useQuery } from '@tanstack/react-query';
import { api, type Post, type TrendingHashtag } from '@/lib/api';

export function useTrendingHashtags() {
  return useQuery({
    queryKey: ['trending', 'hashtags'],
    queryFn: async () => {
      const response = await api.get<TrendingHashtag[]>('/trending/hashtags');

      if (!response.success) {
        throw new Error(response.error?.message || 'Failed to fetch trending hashtags');
      }

      return response.data || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useTrendingPosts() {
  return useQuery({
    queryKey: ['trending', 'posts'],
    queryFn: async () => {
      const response = await api.get<Post[]>('/trending/posts');

      if (!response.success) {
        throw new Error(response.error?.message || 'Failed to fetch trending posts');
      }

      return response.data || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
